import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var RotateCcw = createReactComponent("RotateCcw", ["svg", defaultAttributes, [["path", {
  d: "M3 2v6h6",
  key: "1hhjly"
}], ["path", {
  d: "M3 13a9 9 0 103-7.7L3 8",
  key: "1dt8aq"
}]]]);
export default RotateCcw;